import { Box } from '@mui/material';
import { connect, type ConnectedProps } from 'react-redux';
import { serverUpdateAll } from '@/slices/matches/actions';
import { ModalLayout } from '../../layouts';
import { type ModalContentProps } from '../../../state';
import styles from './styles';

type Props = ConnectedProps<typeof connector> & ModalContentProps;

const ConfirmModal = ({ closeModal, serverUpdateAll }: Props) => {
  const handleDiscard = () => {
    closeModal();
  };

  const handleAccept = () => {
    serverUpdateAll(null);
    closeModal();
  };

  return (
    <ModalLayout
      closeModal={closeModal}
      title="Έχετε μη αποθηκευμένες αλλαγές! "
      onAccept={handleAccept}
      acceptText="Αποθήκευση"
      onCancel={handleDiscard}
      cancelText="Απόρριψη"
    >
      <Box sx={styles.alert}>Θέλετε να τις αποθηκεύσετε πριν προχωρήσετε;</Box>
    </ModalLayout>
  );
};

const connector = connect(null, {
  serverUpdateAll,
});

export default connector(ConfirmModal);
